import { ReactNode } from 'react';
import Footer from './footer/Footer';
import { Box } from '@mui/material';
import Header from './header/Header';

type Props = {
    title: string,
    children: ReactNode
}

const LandingPage = ({ title, children }: Props) => {
    return (<>
        <Header title={title} />
        <Box sx={{minHeight: '100vh', width: '100%' }}>
            {children}
        </Box>
        <Footer />
    </>
    );
}

export default LandingPage;